const AttachmentIcon = ({ color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<defs />
			<path
				fill={color}
				d="M10,3.75 C7.653,3.75 5.75,5.653 5.75,8 L5.75,13.5 C5.75,17.228 8.772,20.25 12.5,20.25 C16.228,20.25 19.25,17.228 19.25,13.5 L19.25,12 C19.25,11.586 19.586,11.25 20,11.25 C20.414,11.25 20.75,11.586 20.75,12 L20.75,13.5 C20.75,18.056 17.056,21.75 12.5,21.75 C7.944,21.75 4.25,18.056 4.25,13.5 L4.25,8 C4.25,4.824 6.824,2.25 10,2.25 C13.176,2.25 15.75,4.824 15.75,8 L15.75,13.5 C15.75,15.295 14.295,16.75 12.5,16.75 C10.705,16.75 9.25,15.295 9.25,13.5 L9.25,9.5 C9.25,9.086 9.586,8.75 10,8.75 C10.414,8.75 10.75,9.086 10.75,9.5 L10.75,13.5 C10.75,14.467 11.533,15.25 12.5,15.25 C13.467,15.25 14.25,14.467 14.25,13.5 L14.25,8 C14.25,5.653 12.347,3.75 10,3.75 Z"
			/>
		</svg>
	);
};

export default AttachmentIcon;
